import { render } from "./PageSection.vue?vue&type=template&id=5d40e114&scoped=true&lang=html"
import script from "./PageSection.vue?vue&type=script&lang=js"
export * from "./PageSection.vue?vue&type=script&lang=js"

import "./PageSection.vue?vue&type=style&index=0&id=5d40e114&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5d40e114"

export default script